import { api, handleResponse, handleError } from "./apiServices";

export const addPrivacyPolicy = (token, data) =>
  api(token)
    .post("/api/privacy_policy/privacyPolicy", data)
    .then(handleResponse)
    .catch(handleError);

export const getPrivacyPolicy = data => {
  console.log("data", data);
  return api()
    .post("/api/privacy_policy/privacyPolicy/getPrivacyPolicy", data)
    .then(handleResponse)
    .catch(handleError);
};
